<template>
  <div
    class="relative mb-5 flex grow overflow-y-auto overflow-x-hidden scroll-shadow xs:p-4 lg:p-4"
  >
    <ul class="mt-2 flex w-full shrink-0 flex-col gap-y-5 p-0">
      <li
        v-for="n in 5"
        :key="n"
        class="relative flex min-h-[88px] items-center overflow-hidden rounded-md bg-gray-200 px-4"
      >
        <div
          class="pointer-events-none absolute inset-0 size-full animate-[shimmer_1.2s_linear_infinite] bg-gradient-to-r from-transparent via-gray-100 to-transparent bg-[length:400px_100%] bg-no-repeat"
        />
      </li>
    </ul>
  </div>
</template>
